import gsap from 'gsap';
import { SplitText } from 'gsap/all';
gsap.registerPlugin(SplitText);

import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Default from './Default';
import WebGLSketch from '../_app/cuchillo/3D/WebGLSketch';
import Scene from '../3D/Scene';
import { GetBy } from '../_app/cuchillo/core/Element';
import Wrap from '../layout/Wrap';
import Preloader from '../layout/Preloader';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Header from '../layout/Header';

export default class Home extends Default {
  /** Home siempre arranca arriba (y no restaura al refrescar). */
  getStartScrollY() {
    Scroll.clearPersistedY();
    return 0;
  }

  _sceneBeforeShow() {
    Scene.seabedEnabled = true; // fons marí al footer (l'scroll-item del footer el crea a Scroll.init)
    WebGLSketch.start();
    Scene.start();
    Scene.show();

    if (this.isFirstTime) {
      Scroll.disable();
      Scene.directShowRender(); // sea a 0 instantani
    }
    
    this._setupShow();        // prepara el text: upper centrat i ocult    
  }

  show__effect(__call) {
    if (this.isFirstTime) {
      Wrap.show(() => {
        Preloader.hide(() => { this.afterShow();
          Scene.setupIntroHome();   // framing: estat inicial + tween ja en marxa. Mar a repòs.
          this._playShow();         // text en paral·lel al framing (no espera afterShow / Wrap)
        });
      }, { duration: 0, delay: 0 });
    } else {
      Wrap.show(() => {
        this.afterShow();
        Scene.setupIntroHome();   // framing: estat inicial + tween ja en marxa. Mar a repòs.
        this._playShow();   
       }, { duration: 0, delay: 0 });
    }

    Header.showNotification();
  }

  // SETUP del text: parteix l'upper en words (ocultes), i col·loca el GRUP (tot menys clients) perquè
  // l'upper quedi al centre de la pantalla.
  _setupShow() {
    this._shown = false;
    const billboard = GetBy.id('BillboardSea');
    if (!billboard) return;
    this._upperEl = billboard.querySelector('.upper');
    this._titleEl = billboard.querySelector('.gradient-title'); // degradat dirigit per --progress-to-top
    this._subtitleEl = billboard.querySelector('.subtitle');
    this._clientsEl = billboard.querySelector('.clients');

    this._upperWords = this._upperEl
      ? new SplitText(this._upperEl, { type: 'words', wordsClass: 'word-child' }).words : [];
    this._group = [this._upperEl, this._titleEl, this._subtitleEl].filter(Boolean); // el "bloc" (menys clients)

    // Estat inicial ocult. Upper: revelem el contenidor i amaguem les words. Subtitle: 1 SOL item a opacity 0.
    // El .title (gradient, via --progress-to-top) i .clients ja neixen ocults pel CSS → els anima _playShow.
    gsap.set(this._upperWords, { opacity: 0 });
    gsap.set(this._upperEl, { opacity: 1 });
    gsap.set([this._subtitleEl].filter(Boolean), { opacity: 0 });

    this._applyCenter(); // baixa el grup perquè l'upper quedi centrat verticalment
  }

  // Offset (recalculat al resize) perquè l'upper quedi al centre vertical del FOLD.
  // Centrem dins del contenidor real (el <div> a 100svh), NO dins window.innerHeight: així el transform
  // de pàgina/scroll i el reveal de Wrap es cancel·len (upper i contenidor comparteixen el mateix sistema
  // de coords via getBoundingClientRect) i funciona igual a mobile (svh ≠ innerHeight) que a desktop.
  _applyCenter() {
    if (this._shown || !this._group || !this._group.length || !this._upperEl) return;
    const container = this._upperEl.parentElement; // el <div> flex-center a 100svh = el "fold"
    if (!container) return;
    const curY = Number(gsap.getProperty(this._upperEl, 'y')) || 0;
    const upperR = this._upperEl.getBoundingClientRect();
    const contR = container.getBoundingClientRect();
    const upperNaturalCenter = (upperR.top + upperR.height / 2) - curY; // centre de l'upper sense el seu translate
    const containerCenter = contR.top + contR.height / 2;              // centre del fold (mateix sistema de coords)
    this._centerOffset = containerCenter - upperNaturalCenter;         // robust a scroll/transform i a svh≠innerHeight
    gsap.set(this._group, { y: this._centerOffset });                  // el grup baixa perquè l'upper quedi al centre
  }

  // PLAY de l'entrada (1r cop, a afterShow).
  _playShow() {
    if (this._shown || !this._group) return;
    this._applyCenter(); // reassegura el centrat ara que la pàgina és visible/laid out
    this._shown = true;

    const tl = gsap.timeline();
    // Framing ja va arrencar a setupIntroHome (_sceneBeforeShow) — no el reiniciem aquí.
    tl.to(this._upperWords, { opacity: 1, duration: 1.4, stagger: 0.25, ease: 'power2.out' }, .2);
    // FASE 2 · delay 1s → translate del grup + gradient del títol + s'acaba l'animació del MAR, i el reveal
    // del subtitle (línies) i els clients.
    tl.addLabel('phase2', '+=1');
    tl.to(this._group, { y: 0, duration: 2, ease: 'power2.out' }, 'phase2');
    if (this._titleEl) tl.to(this._titleEl, { '--progress-to-top': 1, duration: 2.5, ease: 'power2.out' }, 'phase2');
    // subtitle: 1 SOL item, opacity 0 → 1
    if (this._subtitleEl) tl.to(this._subtitleEl, { opacity: 1, duration: 0.75, ease: 'power2.out' }, 'phase2+=0.75');
    // clients: opacitat (està fora del grup → no es translada)
    if (this._clientsEl) tl.to(this._clientsEl, { opacity: 1, duration: 1, ease: 'power2.out' }, 'phase2+=1.25');
    tl.add(() => Scroll.enable());
  }


  beforeHide() {
    super.beforeHide();
    Header.hideNotification();
  }
  
  resize() {
    super.resize();
    this._applyCenter();
  }

  afterShow() {
    super.afterShow();
  }
}

ControllerPage._addPage('home', Home);
